import _ from '../../common/utility';

function actions () {
    $('#facebook').click(() => {
        fburl();
    });

    $('#twitter').click(() => {
        twiturl();
    });

    $('#linkedin').click(() => {
        linkedinurl();
    });

    $('#googleplus').click(() => {
        googleurl();
    });

    $('#whatsapp').click(() => {
        whatsappurl();
    });

    $('#email').click(() => {
        wmdPageLink('ar-share_email');
    })

    $('#socialOpen').click(() => {
        $('#social').show();
    });

    $('#socialClose').click(() => {
        $('#social').hide();
    });
}

export default _.catch(actions);